export default {"src":"/apac/_next/static/media/acros-organics.2d4567a1.svg","height":30,"width":100,"blurWidth":0,"blurHeight":0};